module.exports = __webpack_public_path__ + "static/img/success.70438e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/pay/success.png
// module id = N0nH
// module chunks = 1